<template>
  <div v-if="isValidPdfUrl" class="etc-eek-datasheet">
    <a
        @click="loadPdfViewer"
        href="/#"
        id="loadPdf"
        class="openProduktdatenblattWrapper btn"
        rel="nofollow">{{ $translate("ETCeresCoconut::Template.etcAllgemeinArtikelProduktdatenblatt") }}
    </a>
    <div id="productDatasheetModalWrapper" class="wrapper wrap-left h-100 empty">
      <div class="modalBody bg-white w-100 h-100">
        <div class="modalHeader">
          <div class="title-section">
            {{ $translate("ETCeresCoconut::Template.etcAllgemeinArtikelProduktdatenblatt") }}
          </div>
          <div class="close-modal-button" type="button" @click="closeModal"></div>
        </div>
        <div id="productDatasheetContent" class="modalContent" style="padding: 0 0.001rem 0 0;">
          <template v-if="showPdf">
            <lazy-pdf-viewer :pdf-url="pdfUrl" />
          </template>
        </div>
      </div>
      <div class="overlay" @click="closeModal"></div>
    </div>
  </div>
</template>

<script>
import LazyPdfViewer from "./LazyPdfViewer.vue";
export default {
  name: "pdf-viewer",
  props: {
    pdfUrl: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      showPdf: false,
    };
  },
  computed: {
    isValidPdfUrl() {
      if (!this.pdfUrl) return false;
      const urlPattern = new RegExp(
          "^(https?:\\/\\/)?" + // Protokoll
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // Domainname
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // oder IP (v4)
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // Port und Pfad
          "(\\?[;&a-z\\d%_.~+=-]*)?" + // Query
          "(\\#[-a-z\\d_]*)?$",
          "i"
      );
      return urlPattern.test(this.pdfUrl);
    },
  },
  methods: {
    loadPdfViewer() {
      this.showPdf = true; // PDF wird erst angezeigt, wenn der Button geklickt wird
    },
    closeModal() {
      const modalWrapper = document.getElementById("productDatasheetModalWrapper");
      if (modalWrapper) {
        modalWrapper.classList.remove("open-modal-left");
      }
    }
  },
  components: {
    LazyPdfViewer
  },
};
</script>
